import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import mockedApolloLink from './apolloLinkMock';

const cache = new InMemoryCache();

let link = null;
if (process.env.REACT_APP_APOLLO_URL) {
  link = new HttpLink({
    uri: process.env.REACT_APP_APOLLO_URL
  });
} else {
  link = mockedApolloLink;
}

const client = new ApolloClient({
  cache,
  link
});

export default client;
